module.exports = __webpack_public_path__ + "static/media/show.20d415bf.svg";